module.exports = __webpack_public_path__ + "img/share.bb62f877.svg";